<app-generic-loader [isLoader]="isLoading"></app-generic-loader>
<div class="topics-config-container">

  <!-- Toolbar -->
  <div class="topics-toolbar">
    <div class="topics-label-area">
      <span class="topics-label">Topics</span>
      
      <!-- Info icon when no snapshot configuration -->
      <span class="info-icon" 
            *ngIf="!hasSnapshotConfiguration"
            title="No snapshot configuration found. Please configure snapshot settings first.">
        ⓘ
      </span>

      <!-- Brand select wrapper when snapshot is configured -->
      <div class="brand-select-wrapper" *ngIf="hasSnapshotConfiguration">
        <select class="topics-brand-select" [(ngModel)]="selectedBrand" [title]="getSelectedBrandLabel()">
          <option *ngFor="let b of brandOptions" [value]="b.value" [title]="b.label">{{ b.label }}</option>
        </select>
        <span class="info-icon" 
              *ngIf="!isSelectedBrandConfigured()"
              title="Configure at least one Section/Sub-section to enable the feature.">
          ⓘ
        </span>
      </div>
    </div>
    <div class="topics-action-btns">
      <!-- <span class="info-icon" title="Maximum 200 rows can be added.">ⓘ</span> -->
      <button class="topics-action-btn" [disabled]="!hasSnapshotConfiguration" (click)="addNewRow()">
        <img src="assets/images/common/Add.svg" alt="add"> Add New Row
      </button>
      <button class="topics-action-btn" [disabled]="!hasSnapshotConfiguration" (click)="download()">
        <img src="assets/images/common/download-color-icon.svg" alt="download"> Download
      </button>
      <button class="topics-action-btn" [disabled]="!hasSnapshotConfiguration" (click)="triggerUpload()">
        <img src="assets/images/common/Upload.svg" alt="upload"> Upload
      </button>
      <input type="file" #fileInput style="display:none" (change)="onFileSelected($event)">
    </div>
  </div>

  <!-- Grid: *ngIf recreates the grid on mode switch, discarding unsaved edits -->
  <app-topics-grid *ngIf="topicsLoaded && activeMode === 'default'"
                   [mode]="'default'"
                   [savedRows]="defaultSavedRows"
                   [disabled]="!hasSnapshotConfiguration"
                   [snapshotTypeOptions]="snapshotTypeOptions"
                   [allSnapshotTypeOptions]="allSnapshotTypeOptions"
                   [mandatoryVariableMapping]="mandatoryVariableMapping"
                   [dimensionList]="dimensionList"></app-topics-grid>
  <app-topics-grid *ngIf="topicsLoaded && activeMode === 'bips'"
                   [mode]="'bips'"
                   [savedRows]="bipsSavedRows"
                   [disabled]="!hasSnapshotConfiguration"
                   [snapshotTypeOptions]="snapshotTypeOptions"
                   [allSnapshotTypeOptions]="allSnapshotTypeOptions"
                   [mandatoryVariableMapping]="mandatoryVariableMapping"
                   [dimensionList]="dimensionList"></app-topics-grid>

</div>
  <!-- Footer Buttons -->
  <div class="topics-footer" *ngIf="hasSnapshotConfiguration">
    <div class="SnapshotButtonFields" (click)="submit()">
      <div class="button-img t-submit"></div>
      <div class="SnapshotButton">Submit</div>
    </div>
    <div class="SnapshotButtonFields" (click)="deleteRows()">
      <div class="button-img t-delete"></div>
      <div class="SnapshotButton">Delete</div>
    </div>
    <div class="SnapshotButtonFields" (click)="downloadUserGuide()">
      <div class="button-img t-guide"></div>
      <div class="SnapshotButton">Download User Guide</div>
    </div>
  </div>